import type { SelectOption } from '@/components/SearchableSelect'
import type { MonthSummaryItem } from '@/services/fixedAssets'
import { incomeAllocationMonthsRange, pickOldestNonCompleteMonth } from '@/utils/allocationFormat'
import {
  reportMonthLabel,
  waterfallJeStatusBadgeTone,
  waterfallJeStatusLabel,
} from '../distribution-waterfall/waterfallJeStatus'

export {
  pickOldestNonCompleteMonth,
  reportMonthLabel,
  waterfallJeStatusBadgeTone,
  waterfallJeStatusLabel,
}

/** Map months-summary API → SearchableSelect options. Newest first via incomeAllocationMonthsRange. */
export function mergeFixedAssetMonthSelectOptions(
  apiMonths: MonthSummaryItem[],
  asOf?: Date,
): SelectOption[] {
  const byMonth = new Map(apiMonths.map((entry) => [entry.report_month, entry]))

  return incomeAllocationMonthsRange(asOf).map((reportMonth) => {
    const entry = byMonth.get(reportMonth)
    return {
      id: reportMonth,
      label: reportMonthLabel(reportMonth),
      status: entry?.status ?? 'incomplete',
      hint: entry?.hint ?? undefined,
    }
  })
}
